<template>
	<div class="page">
		<div class="logo">
			<div class="flex-1">
				<img class="logo-img" src="../../static/moblieHome/logo.png" alt="" />
			</div>
			<div class="red blod f14">
				<img class="phone-icon" src="../../static/moblieHome/phone.png" alt="" />400-0552-086
			</div>
		</div>
		<img class="banner" src="../../static/moblieHome/banner.png" alt="" />
		<img class="img-100" src="../../static/moblieHome/img1.png" alt="" />
		<!-- 解决方案 -->
		<div class="solution">
			<div class="title">
				<div class="t">全流程订单管理解决方案</div>
				<div class="font-red">订单实现全流程数据记录，便于高效追踪与管理</div>
			</div>
			<div class="tab">
				<span 
					@click="activeIndex1 = i"
					v-for="(item, i) in tabList1" 
					:key="i" 
					class="tab-item"
					:class="{'active-tab-item': activeIndex1 == i}">{{ item }}</span>
			</div>
			<div class="solution-img">
				<img class="img-100" v-if="activeIndex1 == 0" src="../../static/moblieHome/solution1.png" alt="" />
				<img class="img-100" v-if="activeIndex1 == 1" src="../../static/moblieHome/solution2.png" alt="" />
				<img class="img-100" v-if="activeIndex1 == 2" src="../../static/moblieHome/solution3.png" alt="" />
			</div>
		</div>
		<div class="solution">
			<div class="title">
				<div class="t">全方位智能管理解决方案</div>
				<div class="font-red">助力门店高效运营，降低风险，实现稳健增长</div>
			</div>
			<div class="tab">
				<span 
					@click="activeIndex2 = i"
					v-for="(item, i) in tabList2" 
					:key="i" 
					class="tab-item"
					:class="{'active-tab-item': activeIndex2 == i}">{{ item }}</span>
			</div>
			<div class="solution-img">
				<img class="img-100" v-if="activeIndex2 == 0" src="../../static/moblieHome/solution4.png" alt="" />
				<img class="img-100" v-if="activeIndex2 == 1" src="../../static/moblieHome/solution5.png" alt="" />
				<img class="img-100" v-if="activeIndex2 == 2" src="../../static/moblieHome/solution6.png" alt="" />
			</div>
		</div>
		<img class="img-100" src="../../static/moblieHome/img2.png" alt="" />
		<img class="img-100" src="../../static/moblieHome/store-img.png" alt="" />
		<img class="img-100" src="../../static/moblieHome/img4.png" alt="" />
		<div class="vip-saas">
			<img class="img-100 vip-img mt-20" src="../../static/moblieHome/vip-img1.png" alt="" />
			<!-- <img class="img-100 vip-img" src="../../static/moblieHome/vip-img2.png" alt="" /> -->
			<!-- <img class="img-100 vip-img" src="../../static/moblieHome/vip-img3.png" alt="" /> -->
			<img class="img-100 vip-img" src="../../static/moblieHome/vip-img4.png" alt="" />
		</div>
		<img class="img-100" src="../../static/moblieHome/img5.png" alt="" />
		<div class="code">
			<div class="phone">
				<div class="left">
					<span class="name">联系电话：130-3306-0125</span> <br />
					<span class="c-9">营业执照注册地址</span> <br />
					<span class="c-9">合肥市政务区华邦世贸中心A座</span> <br />
				</div>
				<div class="right">
					<img src="../../static/moblieHome/qr-code.png" alt="" />
				</div>
			</div>
			<div class="record">
				<a href="https://beian.miit.gov.cn/" target="_blank"  style="color: #999;font-size: 12px;">
					互联网ICP备案: 皖ICP备2022006755号
				</a>
			</div>
			<div class="">
				<a href="https://qlximg.xiaoyatou.top/certificate/yingyezhizhao.jpeg" target="_blank" style="color: #999;font-size: 12px;">
					@yundangpu.vip 安徽趣玩网络科技有限公司版权所有
				</a>
			</div>
		</div>
		<div class="footer-mobile">
			<div @click="sidebarActive = true" class="btn1 flex"><img src="../../static/moblieHome/icon1.png" alt="" />立即咨询</div>
			<a href="tel:130-3306-0125" class="btn2 flex c-fff"><img src="../../static/moblieHome/icon2.png" alt="" />电话咨询</a>
		</div>
		<!-- 借款申请 -->
		<div v-if="sidebarActive" class="form" @touchmove.stop.prevent="toMoveHandle">
			<div class="mask" :class="sidebarActive ? 'show' : 'hide'" @click.stop="closeMask()"></div>
			<div class="moblie-loan" :class="{ 'active': sidebarActive }">
				<div class="title">安全/高效/赋能</div>
				<div class="form-ipt">
					<div class="user-ipt">
						<img class="user-icon" src="../../static/recycle/phone-icon.png" alt="" />
						<input maxlength="11" @blur="onBlur" class="ipt" v-model="userPhone" type="text" placeholder="请输入手机号"/>
					</div>
				</div>
				<div class="submit-btn" @click="doSubmit()">立即提交</div>
			</div>
		</div>
		<!-- 申请成功 -->
		<div v-if="show" class="form1" @touchmove.stop.prevent="toMoveHandle">
			<div class="mask" :class="show ? 'show' : 'hide'" @click.stop="closeMask1()"></div>
			<div class="moblie-loan1" :class="{ 'active': show }">
				<img class="success-icon" src="../../static/popup/success.png" alt="" />
				<div class="tit">提交成功</div>
				<div class="red blod">工作人员将在30分钟内联系您～</div>
				<div class="submit-btn" @click="show = false">我知道了</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data () {
			return {
				userName: '',
				userPhone: '',
				sidebarActive: false,
				show: false,
				tabList1: ['电子合同', '智能计算器', '订单管理'],
				tabList2: ['客户风险', '雷达提醒', '业绩统计'],
				activeIndex1: 0,
				activeIndex2: 0,
			}
		},
		methods: {
			onBlur() {
				if (this.phone && !(/^1[3|4|5|6|7|8][0-9]\d{8,8}$/.test(this.phone))) {
					this.phone = ''
					uni.showToast({
						title: '请填写正确的手机号码',
						icon: "none",
						duration: 2000
					})
				}
			},
			doSubmit() {
				this.onBlur()
				if (this.userPhone == '') {
					this.$message.error('请输入手机号');
					return false
				}
				let res = this.util.request({
					url: `/sy/getYunPuWebsite/submitFrom`,
					method: 'POST',
					data: {
						userPhone: this.userPhone,
						clueType: 0,
					},
				}).then(res => {
					if (res.status === 200) {
						this.sidebarActive = false
						this.show = true
					}
				}).catch(error => {
					this.$message.error(error);
				});
			},
			toMoveHandle() {},
			closeMask() {
				if (this.sidebarActive) {
					this.sidebarActive = false
				}
			},
			closeMask1() {
				if (this.show) {
					this.show = false
				}
			},
		}
	}
</script>

<style scoped>
	.page {
		/* text-align: center; */
		background: #F8F8F8;
	}
	.red {
		color: #FE3D3A;
	}
	.logo {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 10;
		height: 4.0625rem;
		line-height: 4.0625rem;
		background: #FFFFFF;
		padding: 0 0.9375rem;
		text-align: left;
		display: flex;
		align-items: center;
		.flex-1 {
			flex: 1;
		}
		.logo-img {
			width: 3.5rem;
			height: 2.1875rem;
			vertical-align: middle;
		}
		.phone-icon {
			width: 16px;
			height: 16px;
			vertical-align: middle;
			margin-right: 5px;
		}
		.blod {
			font-weight: 600;
		}
		.f14 {
			font-size: 14px;
		}
	}
	.banner {
		width: 100%;
		max-width:100%;
		margin-top: 4.0625rem;
		display: block; /* 防止底部出现间隙 */
		pointer-events: none;
		user-select: none; /* 禁止选择文本 */
	}
	.img-100 {
		width: 100%;
		max-width: 100%; /* 图片最大宽度为容器宽度 */
		height: auto;    /* 保持图片原始宽高比 */
		display: block; /* 防止底部出现间隙 */
		margin: 0 auto;
		vertical-align: middle;
	}
	.img-90 {
		max-width: 96%; /* 图片最大宽度为容器宽度 */
		height: auto;    /* 保持图片原始宽高比 */
		display: block; /* 防止底部出现间隙 */
		margin: 0 auto;
		vertical-align: middle;
	}
	.footer-mobile {
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 9;
		display: flex;
		align-items: center;
		height: 44px;
		line-height: 44px;
		font-weight: 500;
		font-size: 16px;
		color: #FFFFFF;
		.btn1 {
			width: 50%;
			background: #FE3D3A;
		}
		.btn2 {
			color: #FFFFFF;
			width: 50%;
			background: #FFAD39;
		}
		.flex {
			display: flex;
			align-items: center;
			justify-content: center;
		}
		img {
			width: 18px;
			height: 18px;
			margin-right: 5px;
		}
	}
	.code {
		background: #333;
		padding: 16px 12px 60px;
	}
	.phone {
		display: flex;
		align-items: center;
		text-align: left;
		padding-bottom: 5px;
		border-bottom: 1px solid #686868;
		.left {
			flex: 1;
			font-weight: normal;
			.name {
				font-size: 14px;
				color: #FFFFFF;
			}
			.c-9 {
				font-size: 12px;
				color: #999999;
			}
		}
		.right {
			img {
				width: 80px;
				height: 80px;
			}
		}
	}
	.record {
		text-align: left;
		margin-top: 12px;
	}
	.mt-20 {
		margin-top: 20px;
	}
	.form {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 10;
		text-align: left;
		.hide {
			display: none;
		}
		.show {
			display: block;
		}
		.mask {
			background: rgba(0, 0, 0, .5);
			width: 100%;
			height: 100vh;
		}
		.moblie-loan {
			padding: 30px;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%,-50%);
			width: 294px;
			background: #FFFFFF;
			border-radius: 8px;
			.title {
				font-weight: 600;
				font-size: 20px;
				color: #333333;
			}
			.form-ipt {
				margin-top: 30px;
			}
			.user-ipt {
				height: 44px;
				line-height: 44px;
				background: #F8F8F8;
				border-radius: 22px;
				border: 1px solid #E2E2E2;
				display: flex;
				align-items: center;
				padding-left: 10px;
				padding-right: 10px;
				margin-bottom: 15px;
			}
			.ipt {
				flex: 1;
				height: 40px;
			}
			.user-icon{
				width: 22px;
				height: 22px;
				margin-right: 10px;
			}
			.submit-btn {
				height: 44px;
				line-height: 44px;
				background: #FE3D3A;
				border-radius: 22px;
				font-weight: 600;
				font-size: 16px;
				color: #FFFFFF;
				text-align: center;
				margin-top: 30px;
			}
		}
	}
	.form1 {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 10;
		text-align: center;
		.hide {
			display: none;
		}
		.show {
			display: block;
		}
		.mask {
			background: rgba(0, 0, 0, .5);
			width: 100%;
			height: 100vh;
		}
		.moblie-loan1 {
			padding: 30px;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%,-50%);
			width: 294px;
			background: #FFFFFF;
			border-radius: 8px;
		}
		.tit { 
			font-weight: 600;
			font-size: 20px;
			color: #333333;
		}
		.success-icon {
			width: 64px;
			height: 108px;
		}
		.submit-btn {
			height: 44px;
			line-height: 44px;
			background: #CF2427;
			border-radius: 22px;
			font-weight: 600;
			font-size: 16px;
			color: #FFFFFF;
			text-align: center;
			margin-top: 30px;
		}
	}
	.vip-saas {
		padding: 0 10px;
	}
	.vip-img {
		margin-bottom: 10px;
	}
	.solution {
		padding-top: 20px;
		background-color: #fff;
		.title {
			text-align: center;
			font-size: 11px;
		}
		.t {
			font-size: 20px;
			color: #333333;
			font-weight: 600;
			margin-bottom: 6px;
		}
		.tab {
			text-align: center;
			margin: 20px 40px;
			border-bottom: 1px solid #F2F2F2;
			display: flex;
			align-items: center;
		}
		.tab-item {
			display: inline-block;
			font-size: 14px;
			color: #999999;
			padding-bottom: 8px;
			flex: 1;
		}
		.tab-item:last-child {
			margin-right: 0;
		}
		.active-tab-item {
			color: #FE3D3A;
			font-weight: 600;
			border-bottom: 1px solid #FE3D3A;
		}
		.solution-img {
			padding: 0 12px 20px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/view/moblieHome.vue